module.exports = __webpack_public_path__ + "img/projects.417b14f0.svg";